import React from "react";
import { Navigate } from "react-router-dom";
import Auth from "../../configs/Auth";
import LoggedInLayout from "../../layouts/LoggedInLayout";
import routes from "../routesCode";

const AuthRoute = ({ children }) => {
  if (!Auth.isAuthenticated()) {
    return <Navigate to={routes.logIn.path} replace />;
  }

  return <LoggedInLayout>{children}</LoggedInLayout>;
};

export default AuthRoute;
